_N_E =
(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[26],{

/***/ "+ZT0":
/***/ (function(module, exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/zglos-serwis",
      function () {
        return __webpack_require__("Prhq");
      }
    ]);
  

/***/ }),

/***/ "1OyB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _classCallCheck; });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ "1wk4":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"form":"addContentCreatorForm_form__1fv7l","errorContainer":"addContentCreatorForm_errorContainer__2_x5T","formLoading":"addContentCreatorForm_formLoading__GJ7S2","label":"addContentCreatorForm_label__2bmrV","errorMessage":"addContentCreatorForm_errorMessage__1GLu5","input":"addContentCreatorForm_input__1uCQH","wrapper":"addContentCreatorForm_wrapper__1ZlFS"};

/***/ }),

/***/ "3eZH":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"addContentCreatorSection_section__3cdwu","heading":"addContentCreatorSection_heading__2XsX2"};

/***/ }),

/***/ "89Ff":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Button; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rePB");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("Ff2n");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("nKUr");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("iuhU");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _button_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("TmFx");
/* harmony import */ var _button_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_button_module_scss__WEBPACK_IMPORTED_MODULE_5__);





function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var Button = /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_4__["memo"])( /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_4__["forwardRef"])(function (_ref, ref) {
  var _clsx;

  var _ref$as = _ref.as,
      As = _ref$as === void 0 ? 'button' : _ref$as,
      icon = _ref.icon,
      children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$iconPosition = _ref.iconPosition,
      iconPosition = _ref$iconPosition === void 0 ? 'left' : _ref$iconPosition,
      _ref$buttonStyle = _ref.buttonStyle,
      buttonStyle = _ref$buttonStyle === void 0 ? 'normal' : _ref$buttonStyle,
      props = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["as", "icon", "children", "className", "iconPosition", "buttonStyle"]);

  return /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__["jsxs"])(As, _objectSpread(_objectSpread({
    className: Object(clsx__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_button_module_scss__WEBPACK_IMPORTED_MODULE_5___default.a.button, className, (_clsx = {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_clsx, _button_module_scss__WEBPACK_IMPORTED_MODULE_5___default.a.buttonIconRight, iconPosition === 'right'), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_clsx, _button_module_scss__WEBPACK_IMPORTED_MODULE_5___default.a.buttonDanger, buttonStyle === 'danger'), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_clsx, _button_module_scss__WEBPACK_IMPORTED_MODULE_5___default.a.buttonDisabled, props.disabled), _clsx)) // @ts-ignore
    ,
    ref: ref
  }, props), {}, {
    children: [icon && /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__["jsx"])("span", {
      className: Object(clsx__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(icon, children && _button_module_scss__WEBPACK_IMPORTED_MODULE_5___default.a.icon)
    }), children]
  }));
}));
Button.displayName = 'Button';

/***/ }),

/***/ "93az":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__("q1tI");

// Borrowed from https://github.com/ai/nanoid/blob/3.0.2/non-secure/index.js
// This alphabet uses `A-Za-z0-9_-` symbols. A genetic algorithm helped
// optimize the gzip compression for this alphabet.
var urlAlphabet = 'ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW';

var nanoid = function nanoid() {
  var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 21;

  var id = '';
  // A compact alternative for `for (var i = 0; i < step; i++)`.
  var i = size;
  while (i--) {
    // `| 0` is more compact and faster than `Math.floor()`.
    id += urlAlphabet[Math.random() * 64 | 0];
  }
  return id;
};

// Create script to init hCaptcha
var onLoadListeners = [];
var captchaScriptCreated = false;

// Generate hCaptcha API Script
var CaptchaScript = function CaptchaScript(hl, reCaptchaCompat) {
  // Create global onload callback
  window.hcaptchaOnLoad = function () {
    // Iterate over onload listeners, call each listener
    onLoadListeners = onLoadListeners.filter(function (listener) {
      listener();
      return false;
    });
  };

  var script = document.createElement("script");
  script.src = "https://hcaptcha.com/1/api.js?render=explicit&onload=hcaptchaOnLoad";
  script.async = true;
  if (hl) {
    script.src += '&hl=' + hl;
  }
  if (reCaptchaCompat === false) {
    script.src += '&recaptchacompat=off';
  }

  document.head.appendChild(script);
};

var HCaptcha = function (_React$Component) {
  _inherits(HCaptcha, _React$Component);

  function HCaptcha(props) {
    _classCallCheck(this, HCaptcha);

    var _this = _possibleConstructorReturn(this, (HCaptcha.__proto__ || Object.getPrototypeOf(HCaptcha)).call(this, props));

    var _props$id = props.id,
        id = _props$id === undefined ? null : _props$id;

    // API Methods

    _this.renderCaptcha = _this.renderCaptcha.bind(_this);
    _this.resetCaptcha = _this.resetCaptcha.bind(_this);
    _this.removeCaptcha = _this.removeCaptcha.bind(_this);

    // Event Handlers
    _this.handleOnLoad = _this.handleOnLoad.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handleExpire = _this.handleExpire.bind(_this);
    _this.handleError = _this.handleError.bind(_this);

    var isApiReady = typeof hcaptcha !== 'undefined';

    if (!isApiReady) captchaScriptCreated = false;

    _this.state = {
      isApiReady: isApiReady,
      isRemoved: false,
      elementId: id || 'hcaptcha-' + nanoid(),
      captchaId: ''
    };
    return _this;
  }

  _createClass(HCaptcha, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      //Once captcha is mounted intialize hCaptcha - hCaptcha
      var _props = this.props,
          languageOverride = _props.languageOverride,
          reCaptchaCompat = _props.reCaptchaCompat;
      var _state = this.state,
          isApiReady = _state.isApiReady,
          elementId = _state.elementId;


      if (!isApiReady) {
        //Check if hCaptcha has already been loaded, if not create script tag and wait to render captcha elementID - hCaptcha

        if (!captchaScriptCreated) {
          // Only create the script tag once, use a global variable to track
          captchaScriptCreated = true;
          CaptchaScript(languageOverride, reCaptchaCompat);
        }

        // Add onload callback to global onload listeners
        onLoadListeners.push(this.handleOnLoad);
      } else {
        this.renderCaptcha();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _state2 = this.state,
          isApiReady = _state2.isApiReady,
          isRemoved = _state2.isRemoved,
          captchaId = _state2.captchaId;

      if (!isApiReady || isRemoved) return;

      // Reset any stored variables / timers when unmounting
      hcaptcha.reset(captchaId);
      hcaptcha.remove(captchaId);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      // Prevent component re-rendering when these internal state variables are updated
      if (this.state.isApiReady !== nextState.isApiReady || this.state.isRemoved !== nextState.isRemoved) {
        return false;
      }

      return true;
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      var endpoint = this.props.endpoint;

      // Prop Keys that could change

      var keys = ['sitekey', 'size', 'theme', 'tabindex', 'languageOverride', 'endpoint'];
      // See if any props changed during component update
      var match = keys.every(function (key) {
        return prevProps[key] === _this2.props[key];
      });

      // If they have changed, remove current captcha and render a new one
      if (!match) {
        this.removeCaptcha();
        this.renderCaptcha();
      }
    }
  }, {
    key: 'renderCaptcha',
    value: function renderCaptcha() {
      var _state3 = this.state,
          isApiReady = _state3.isApiReady,
          elementId = _state3.elementId;

      if (!isApiReady) return;

      //Render hCaptcha widget and provide neccessary callbacks - hCaptcha
      var captchaId = hcaptcha.render(document.getElementById(elementId), _extends({}, this.props, {
        "error-callback": this.handleError,
        "expired-callback": this.handleExpire,
        "callback": this.handleSubmit
      }));

      this.setState({ isRemoved: false, captchaId: captchaId });
    }
  }, {
    key: 'resetCaptcha',
    value: function resetCaptcha() {
      var _state4 = this.state,
          isApiReady = _state4.isApiReady,
          isRemoved = _state4.isRemoved,
          captchaId = _state4.captchaId;


      if (!isApiReady || isRemoved) return;
      // Reset captcha state, removes stored token and unticks checkbox
      hcaptcha.reset(captchaId);
    }
  }, {
    key: 'removeCaptcha',
    value: function removeCaptcha() {
      var _state5 = this.state,
          isApiReady = _state5.isApiReady,
          isRemoved = _state5.isRemoved,
          captchaId = _state5.captchaId;


      if (!isApiReady || isRemoved) return;

      this.setState({ isRemoved: true }, function () {
        hcaptcha.remove(captchaId);
      });
    }
  }, {
    key: 'handleOnLoad',
    value: function handleOnLoad() {
      var _this3 = this;

      this.setState({ isApiReady: true }, function () {
        _this3.renderCaptcha();
      });
    }
  }, {
    key: 'handleSubmit',
    value: function handleSubmit(event) {
      var onVerify = this.props.onVerify;
      var _state6 = this.state,
          isRemoved = _state6.isRemoved,
          captchaId = _state6.captchaId;


      if (typeof hcaptcha === 'undefined' || isRemoved) return;

      var token = hcaptcha.getResponse(captchaId); //Get response token from hCaptcha widget
      var ekey = hcaptcha.getRespKey(captchaId); //Get current challenge session id from hCaptcha widget
      onVerify(token, ekey); //Dispatch event to verify user response
    }
  }, {
    key: 'handleExpire',
    value: function handleExpire() {
      var onExpire = this.props.onExpire;
      var _state7 = this.state,
          isApiReady = _state7.isApiReady,
          isRemoved = _state7.isRemoved,
          captchaId = _state7.captchaId;


      if (!isApiReady || isRemoved) return;
      hcaptcha.reset(captchaId); // If hCaptcha runs into error, reset captcha - hCaptcha

      if (onExpire) onExpire();
    }
  }, {
    key: 'handleError',
    value: function handleError(event) {
      var onError = this.props.onError;
      var _state8 = this.state,
          isApiReady = _state8.isApiReady,
          isRemoved = _state8.isRemoved,
          captchaId = _state8.captchaId;


      if (!isApiReady || isRemoved) return;

      hcaptcha.reset(captchaId); // If hCaptcha runs into error, reset captcha - hCaptcha
      if (onError) onError(event);
    }
  }, {
    key: 'execute',
    value: function execute() {
      var _state9 = this.state,
          isApiReady = _state9.isApiReady,
          isRemoved = _state9.isRemoved,
          captchaId = _state9.captchaId;


      if (!isApiReady || isRemoved) return;

      hcaptcha.execute(captchaId);
    }
  }, {
    key: 'render',
    value: function render() {
      var elementId = this.state.elementId;

      return React.createElement('div', { id: elementId });
    }
  }]);

  return HCaptcha;
}(React.Component);

module.exports = HCaptcha;

/***/ }),

/***/ "Ff2n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ _objectWithoutProperties; });

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ "HaE+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _asyncToGenerator; });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

/***/ }),

/***/ "JX7q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _assertThisInitialized; });
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),

/***/ "Ji7U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _inherits; });
/* harmony import */ var _babel_runtime_helpers_esm_setPrototypeOf__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("s4An");

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object(_babel_runtime_helpers_esm_setPrototypeOf__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(subClass, superClass);
}

/***/ }),

/***/ "Prhq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "default", function() { return /* binding */ AddContentCreatorPage; });

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__("nKUr");

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__("YFqc");
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("rePB");

// EXTERNAL MODULE: ./node_modules/@hcaptcha/react-hcaptcha/dist/index.js
var dist = __webpack_require__("93az");
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__("iuhU");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");

// EXTERNAL MODULE: ./hooks/useMutation.tsx
var useMutation = __webpack_require__("SMAk");

// CONCATENATED MODULE: ./utils/api/addContentCreator.ts
var addContentCreator = function addContentCreator(requestBody) {
  return fetch("/api/content-creator", {
    method: 'POST',
    body: JSON.stringify(requestBody)
  });
};
// EXTERNAL MODULE: ./components/Button/Button.tsx
var Button = __webpack_require__("89Ff");

// EXTERNAL MODULE: ./components/AddContentCreatorForm/FormStatus.module.css
var FormStatus_module = __webpack_require__("RfGG");
var FormStatus_module_default = /*#__PURE__*/__webpack_require__.n(FormStatus_module);

// CONCATENATED MODULE: ./components/AddContentCreatorForm/FormStatus.tsx





var errorToMessage = {
  409: 'Blog o podanym adresie został już dodany do naszej bazy danych. Jeżeli nie pojawiają się najnowsze wpisy, lub masz inne zastrzeżenia - proszę skontaktuj się z administratorem.',
  422: 'Nie udało się odnaleźć pliku RSS na twojej stronie, jeśli ten błąd się powtarza, proszę skontaktuj się z administratorem.'
};
var defaultErrorMessage = 'Wystąpił błąd podczas dodawania nowego serwisu, sprawdź poprawność danych i spróbuj ponownie';

function getStatusMessage(_ref) {
  var _errorToMessage$error;

  var status = _ref.status,
      errorCode = _ref.errorCode;

  switch (status) {
    case 'loading':
      return 'Oczekiwanie...';

    case 'success':
      return 'Dziękujemy za zgłoszenie, dodany serwis pojawi się na stronie po zaakceptowaniu przez administrację';

    case 'error':
      return errorCode ? (_errorToMessage$error = errorToMessage[errorCode]) !== null && _errorToMessage$error !== void 0 ? _errorToMessage$error : defaultErrorMessage : defaultErrorMessage;

    default:
      return null;
  }
}

var FormStatus = /*#__PURE__*/Object(react["memo"])(function (_ref2) {
  var status = _ref2.status,
      errorCode = _ref2.errorCode;

  if (status === 'idle') {
    return null;
  }

  return /*#__PURE__*/Object(jsx_runtime["jsxs"])("div", {
    className: FormStatus_module_default.a.statusContainer,
    children: [/*#__PURE__*/Object(jsx_runtime["jsx"])("span", {
      className: Object(clsx_m["a" /* default */])(FormStatus_module_default.a.statusIcon, {
        'icon-spinner': status === 'loading',
        'icon-checkmark': status === 'success',
        'icon-error': status === 'error'
      })
    }), /*#__PURE__*/Object(jsx_runtime["jsx"])("span", {
      children: getStatusMessage({
        status: status,
        errorCode: errorCode
      })
    })]
  });
});
FormStatus.displayName = 'FormStatus';
// EXTERNAL MODULE: ./components/AddContentCreatorForm/addContentCreatorForm.module.scss
var addContentCreatorForm_module = __webpack_require__("1wk4");
var addContentCreatorForm_module_default = /*#__PURE__*/__webpack_require__.n(addContentCreatorForm_module);

// CONCATENATED MODULE: ./components/AddContentCreatorForm/AddContentCreatorForm.tsx




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









var AddContentCreatorForm_AddContentCreatorForm = function AddContentCreatorForm() {
  var _useState = Object(react["useState"])({
    contentURL: '',
    email: ''
  }),
      fields = _useState[0],
      setFields = _useState[1];

  var _useState2 = Object(react["useState"])(null),
      token = _useState2[0],
      setToken = _useState2[1];

  var _useState3 = Object(react["useState"])({}),
      touched = _useState3[0],
      setTouched = _useState3[1];

  var captchaRef = Object(react["useRef"])(null);
  var formRef = Object(react["useRef"])(null);

  var _useState4 = Object(react["useState"])(false),
      isFormValid = _useState4[0],
      setIsFormValid = _useState4[1];

  var _useMutation = Object(useMutation["a" /* useMutation */])(addContentCreator),
      mutate = _useMutation.mutate,
      status = _useMutation.status,
      errorCode = _useMutation.errorCode;

  Object(react["useEffect"])(function () {
    if (status === 'success') {
      setFields({
        contentURL: '',
        email: ''
      });
      setTouched({});
    }
  }, [status]);
  var handleChange = Object(react["useCallback"])(function (_ref) {
    var _formRef$current;

    var currentTarget = _ref.currentTarget;
    setTouched(function (touched) {
      return _objectSpread(_objectSpread({}, touched), {}, Object(defineProperty["a" /* default */])({}, currentTarget.name, true));
    });
    setFields(function (fields) {
      return _objectSpread(_objectSpread({}, fields), {}, Object(defineProperty["a" /* default */])({}, currentTarget.name, currentTarget.value));
    });
    setIsFormValid(((_formRef$current = formRef.current) === null || _formRef$current === void 0 ? void 0 : _formRef$current.checkValidity()) || false);
  }, []);

  var handleSubmit = function handleSubmit(e) {
    e.preventDefault();

    if (token) {
      var _captchaRef$current;

      setToken(null);
      (_captchaRef$current = captchaRef.current) === null || _captchaRef$current === void 0 ? void 0 : _captchaRef$current.resetCaptcha();
      void mutate(_objectSpread(_objectSpread({}, fields), {}, {
        captchaToken: token
      }));
    }
  };

  var handleCaptchaExpire = Object(react["useCallback"])(function () {
    setToken(null);
  }, []);
  var handleCaptchaError = Object(react["useCallback"])(function () {
    setToken(null);
  }, []);

  if (false) {}

  var isLoading = status === 'loading';
  var isButtonDisabled = isLoading || !isFormValid || !token;
  return /*#__PURE__*/Object(jsx_runtime["jsxs"])("form", {
    onSubmit: handleSubmit,
    className: Object(clsx_m["a" /* default */])(addContentCreatorForm_module_default.a.form, isLoading && addContentCreatorForm_module_default.a.formLoading),
    ref: formRef,
    children: [/*#__PURE__*/Object(jsx_runtime["jsxs"])("label", {
      className: addContentCreatorForm_module_default.a.label,
      children: ["Adres URL", /*#__PURE__*/Object(jsx_runtime["jsx"])("input", {
        className: addContentCreatorForm_module_default.a.input,
        value: fields.contentURL,
        name: "contentURL",
        onChange: handleChange,
        placeholder: "Podaj adres URL",
        required: true,
        type: "url"
      }), touched['contentURL'] && /*#__PURE__*/Object(jsx_runtime["jsx"])("span", {
        className: addContentCreatorForm_module_default.a.errorMessage,
        children: "Wprowadzony adres URL jest nieprawid\u0142owy"
      })]
    }), /*#__PURE__*/Object(jsx_runtime["jsxs"])("label", {
      className: addContentCreatorForm_module_default.a.label,
      children: ["Adres email", /*#__PURE__*/Object(jsx_runtime["jsx"])("input", {
        className: addContentCreatorForm_module_default.a.input,
        value: fields.email,
        name: "email",
        onChange: handleChange,
        placeholder: "Podaj sw\xF3j email",
        required: true,
        type: "email"
      }), touched['email'] && /*#__PURE__*/Object(jsx_runtime["jsx"])("span", {
        className: addContentCreatorForm_module_default.a.errorMessage,
        children: "Wprowadzony adres email jest nieprawid\u0142owy"
      })]
    }), /*#__PURE__*/Object(jsx_runtime["jsxs"])("div", {
      className: addContentCreatorForm_module_default.a.wrapper,
      children: [/*#__PURE__*/Object(jsx_runtime["jsx"])(dist_default.a, {
        sitekey: "023027cc-4ffc-403a-b05d-21c28b1b9b2e",
        onVerify: setToken,
        onExpire: handleCaptchaExpire,
        onError: handleCaptchaError,
        ref: captchaRef,
        languageOverride: "pl",
        size: "compact"
      }), /*#__PURE__*/Object(jsx_runtime["jsx"])(Button["a" /* Button */], {
        type: "submit",
        disabled: isButtonDisabled,
        children: "Zg\u0142o\u015B"
      })]
    }), /*#__PURE__*/Object(jsx_runtime["jsx"])(FormStatus, {
      status: status,
      errorCode: errorCode
    })]
  });
};
// EXTERNAL MODULE: ./components/AddContentCreatorSection/addContentCreatorSection.module.css
var addContentCreatorSection_module = __webpack_require__("3eZH");
var addContentCreatorSection_module_default = /*#__PURE__*/__webpack_require__.n(addContentCreatorSection_module);

// CONCATENATED MODULE: ./components/AddContentCreatorSection/AddContentCreatorSection.tsx






var AddContentCreatorSection_AddContentCreatorSection = function AddContentCreatorSection() {
  return /*#__PURE__*/Object(jsx_runtime["jsxs"])("section", {
    className: addContentCreatorSection_module_default.a.section,
    children: [/*#__PURE__*/Object(jsx_runtime["jsx"])("h2", {
      className: addContentCreatorSection_module_default.a.heading,
      children: "Zg\u0142o\u015B Serwis"
    }), /*#__PURE__*/Object(jsx_runtime["jsx"])(link_default.a, {
      href: "/",
      passHref: true,
      children: /*#__PURE__*/Object(jsx_runtime["jsx"])(Button["a" /* Button */], {
        as: "a",
        icon: "icon-arrow-left2",
        children: "Strona g\u0142\xF3wna"
      })
    }), /*#__PURE__*/Object(jsx_runtime["jsx"])(AddContentCreatorForm_AddContentCreatorForm, {})]
  });
};
// EXTERNAL MODULE: ./components/Layout.tsx + 4 modules
var Layout = __webpack_require__("apO0");

// CONCATENATED MODULE: ./pages/zglos-serwis.tsx



function AddContentCreatorPage() {
  return /*#__PURE__*/Object(jsx_runtime["jsx"])(Layout["a" /* Layout */], {
    title: "Zg\u0142o\u015B serwis",
    children: /*#__PURE__*/Object(jsx_runtime["jsx"])(AddContentCreatorSection_AddContentCreatorSection, {})
  });
}

/***/ }),

/***/ "RfGG":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"statusContainer":"FormStatus_statusContainer__36VA3","statusIcon":"FormStatus_statusIcon__35zTw"};

/***/ }),

/***/ "SMAk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useMutation; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rePB");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("o0o1");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("HaE+");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_fetcher__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("UZjq");




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



function useMutation(mutation) {
  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_3__["useState"])({
    status: 'idle'
  }),
      status = _useState[0],
      setStatus = _useState[1];

  var mutate = Object(react__WEBPACK_IMPORTED_MODULE_3__["useCallback"])( /*#__PURE__*/function () {
    var _ref = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.mark(function _callee(body) {
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setStatus({
                status: 'loading'
              });
              _context.prev = 1;
              _context.next = 4;
              return mutation(body);

            case 4:
              setStatus({
                status: 'success'
              });
              _context.next = 12;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](1);

              if (_context.t0 instanceof _utils_fetcher__WEBPACK_IMPORTED_MODULE_4__[/* ResponseError */ "a"]) {
                setStatus({
                  status: 'error',
                  errorCode: _context.t0.status
                });
              }

              setStatus({
                status: 'error'
              });
              throw _context.t0;

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 7]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [mutation]);
  return _objectSpread({
    mutate: mutate
  }, status);
}

/***/ }),

/***/ "TmFx":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__58Y2e","buttonIconRight":"button_buttonIconRight__1aVop","icon":"button_icon__1D0K9","buttonDanger":"button_buttonDanger__n621T","buttonDisabled":"button_buttonDisabled__1L1QL"};

/***/ }),

/***/ "U8pU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _typeof; });
function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

/***/ }),

/***/ "UZjq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ fetcher; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ fetcher_ResponseError; });

// EXTERNAL MODULE: ./node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("o0o1");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("rePB");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("1OyB");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("JX7q");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("Ji7U");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("md7G");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("foSv");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
var setPrototypeOf = __webpack_require__("s4An");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/isNativeFunction.js
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/construct.js


function construct_construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    construct_construct = Reflect.construct;
  } else {
    construct_construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) Object(setPrototypeOf["a" /* default */])(instance, Class.prototype);
      return instance;
    };
  }

  return construct_construct.apply(null, arguments);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js




function wrapNativeSuper_wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  wrapNativeSuper_wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return construct_construct(Class, arguments, Object(getPrototypeOf["a" /* default */])(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return Object(setPrototypeOf["a" /* default */])(Wrapper, Class);
  };

  return wrapNativeSuper_wrapNativeSuper(Class);
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("HaE+");

// CONCATENATED MODULE: ./utils/fetcher.ts










function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = fetcher_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function fetcher_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function fetcher(_x, _x2) {
  return _fetcher.apply(this, arguments);
}

function _fetcher() {
  _fetcher = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(path, _ref) {
    var method, body, config, schema, response;
    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            method = _ref.method, body = _ref.body, config = _ref.config, schema = _ref.schema;
            _context.prev = 1;
            _context.next = 4;
            return fetch(path, _objectSpread(_objectSpread({}, config), {}, {
              headers: {
                'Content-Type': 'application/json'
              },
              credentials: 'include',
              method: method
            }, body && {
              body: JSON.stringify(body)
            }));

          case 4:
            response = _context.sent;

            if (!response.ok) {
              _context.next = 13;
              break;
            }

            if (schema) {
              _context.next = 8;
              break;
            }

            return _context.abrupt("return", null);

          case 8:
            _context.t0 = schema;
            _context.next = 11;
            return response.json()["catch"](function () {});

          case 11:
            _context.t1 = _context.sent;
            return _context.abrupt("return", _context.t0.cast.call(_context.t0, _context.t1));

          case 13:
            throw new fetcher_ResponseError(response.statusText, response.status);

          case 16:
            _context.prev = 16;
            _context.t2 = _context["catch"](1);

            if (!(_context.t2 instanceof fetcher_ResponseError)) {
              _context.next = 20;
              break;
            }

            throw _context.t2;

          case 20:
            throw new fetcher_ResponseError('Something went wrong during fetching!');

          case 21:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 16]]);
  }));
  return _fetcher.apply(this, arguments);
}

var fetcher_ResponseError = /*#__PURE__*/function (_Error) {
  Object(inherits["a" /* default */])(ResponseError, _Error);

  var _super = _createSuper(ResponseError);

  function ResponseError(message, status) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, ResponseError);

    _this = _super.call(this, message); // eslint-disable-next-line functional/no-this-expression

    _this.status = status;
    _this.name = 'ResponseError'; // eslint-disable-next-line functional/no-this-expression

    Object.setPrototypeOf(Object(assertThisInitialized["a" /* default */])(_this), ResponseError.prototype);
    return _this;
  }

  return ResponseError;
}( /*#__PURE__*/wrapNativeSuper_wrapNativeSuper(Error));

/***/ }),

/***/ "foSv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _getPrototypeOf; });
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),

/***/ "iuhU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function toVal(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

/* harmony default export */ __webpack_exports__["a"] = (function () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal(tmp)) {
				str && (str += ' ');
				str += x
			}
		}
	}
	return str;
});


/***/ }),

/***/ "md7G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _possibleConstructorReturn; });
/* harmony import */ var _babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("U8pU");
/* harmony import */ var _babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("JX7q");


function _possibleConstructorReturn(self, call) {
  if (call && (Object(_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(call) === "object" || typeof call === "function")) {
    return call;
  }

  return Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(self);
}

/***/ }),

/***/ "s4An":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _setPrototypeOf; });
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/***/ })

},[["+ZT0",1,0,2,4,3,5,6]]]);